var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"Auth"},[_c('Overlay'),_c('div',{staticClass:"Auth__logo"},[_c('img',{attrs:{"src":require("@/assets/img/SwyftLandingLogo.png"),"alt":""}})]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }